const Footer = () => <footer className="bg-gray-200">
    <div className="container mx-auto text-center py-5">
        &copy; {new Date().getFullYear()} <span className="font-bold">NyírPonyva</span>. Minden jog fenntartva.
    </div>
</footer>

export default Footer;